import { LayoutDashboard } from '@tamagui/lucide-icons';
import { Page } from '@unistocks/components/page/page';
import { Tab, Tabs } from '@unistocks/components/tabs/tabs';
import { EmailSettings } from '@unistocks/features/admin/components/settings/email-settings';
import { IdentitySettings } from '@unistocks/features/admin/components/settings/identity-settings';
import { usePermission } from '@unistocks/shared/hooks/use-permission';
import { t } from '@unistocks/shared/localization/index.ts';
import { UnistocksPermissions } from '@unistocks/shared/permissions';

const renderTab = (tabValue: string) => {
  switch (tabValue) {
    case 'emailing':
      return <EmailSettings />;
    case 'identity-management':
      return <IdentitySettings />;
    case 'feature-management':
    default:
      return null;
  }
};

export const AdminSettings: React.FC = () => {
  const hasEmailing = usePermission(UnistocksPermissions.SettingManagementEmailing);
  const hasIdentity = usePermission(UnistocksPermissions.SettingManagementIdentity);
  const hasFeatureManagement = usePermission(UnistocksPermissions.SettingManagementFeatures);

  const tabs: Tab[] = [
    { value: 'emailing', label: t('AbpSettingManagement::Menu:Emailing'), disabled: !hasEmailing },
    {
      value: 'identity-management',
      label: t('AbpIdentity::Menu:IdentityManagement'),
      disabled: !hasIdentity
    },
    {
      value: 'feature-management',
      label: t('AbpFeatureManagement::Menu:FeatureManagement'),
      disabled: !hasFeatureManagement
    }
  ];

  return (
    <Page size="medium">
      <Page.ScrollView
        contentContainerStyle={{ gap: '$4' }}
        headerTitle={t('AbpSettingManagement::Settings')}
        breadcrumbs={[
          {
            key: 'admin',
            href: '/(admin)',
            name: t('::Menu:Administration'),
            rootPathName: 'admin',
            Icon: props => <LayoutDashboard {...props} />
          }
        ]}
      >
        <Tabs tabs={tabs} renderTab={renderTab} tabListProps={{ bg: '$color3' }} />
      </Page.ScrollView>
    </Page>
  );
};

AdminSettings.displayName = 'AdminSettings';
